export default __webpack_public_path__ + "static/media/home-yoga-meditation-facility-img04.9c40afe1.jpg";